export default __webpack_public_path__ + "static/12_30-2fd3bab61dac30782410ec31377a6657.png";